import { z } from 'zod';
import { ModelDefinition } from '../base-components/hooks/useModel';
import { getProduct, saveProduct, createProductAndGetId } from '../api/product-controller';
import { RoutePath } from '@/generic/config';

export const ProductSchema = z.object({
    id: z.number(),
    code: z.string(),
    enabled: z.boolean(),
    /** Show this product's count on the crew Tasks page (and let crew edit it when completing). */
    showOnTasks: z.boolean().optional().default(false),
    /** Font Awesome icon name from the product-icons catalog (e.g. "trash-can"); empty = no icon. */
    taskIcon: z.string().nullable().optional().default(""),
    /** Display order on the Tasks page (lower first). */
    taskSort: z.coerce.number().optional().default(0),
});

type Product = z.infer<typeof ProductSchema>;

export default Product;

export const emptyProductObject: Product = {
    id: 0,
    code: "",
    enabled: true,
    showOnTasks: false,
    taskIcon: "",
    taskSort: 0,
};

export const ProductModel: ModelDefinition<Product> = {
    getById: getProduct,
    saveFromModel: saveProduct,
    createFromModel: createProductAndGetId,
    validationMessages: () => [],
    routePath: RoutePath.Products,
    typeProviderObject: ProductSchema.parse(emptyProductObject),
};